import React, { useState } from "react";
import PropTypes from "prop-types";

import { Field, Control, Label } from "rbx";
import { BooleanInput, SystemCodeSelect } from "../../../components/inputs";

import FilterButtons from "../../../components/FilterButtons";

const INITIAL_FILTER_STATE = {
  Active: true
};
function ItemCategoryFilters({ filters, onFilter, onClose, onReset }) {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const updates = { ...inputs };
    if (e.target.name.includes("RecIdRef")) {
      updates[e.target.name] = parseInt(value, 10);
    } else {
      updates[e.target.name] = value;
    }
    setInputs({ ...updates });
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () =>
    onReset ? onReset() : onClose(onFilter({ ...INITIAL_FILTER_STATE }));
  return (
    <div style={{ width: 400, maxWidth: "80vw" }}>
      <Field kind="group">
        <Control expanded>
          <SystemCodeSelect
            icon="globe"
            label="Item Category Type"
            name="ItemCatgTypeRecIdRef"
            value={inputs.ItemCatgTypeRecIdRef}
            where={{ Category: "Fleet", CodeName: "WOType" }}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Active</Label>
          <BooleanInput
            name="Active"
            value={inputs.Active}
            onChange={handleChange}
          />
        </Control>
      </Field>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </div>
  );
}
ItemCategoryFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func,
  onReset: PropTypes.func
};
ItemCategoryFilters.defaultProps = {
  filters: {}
};
export default ItemCategoryFilters;
